






import { ITag } from '@/interfaces';
import Vue from 'vue';

export default Vue.extend({
  props: ['tag', 'canDelete', 'isusj', 'isonfb', 'isonig', 'isonweb', 'ismij'],
  data() {
    return {
      bgcolor: this.$props.isusj ? 'amber darken-2' :
             this.$props.isonfb ? 'blue darken-2' :
             this.$props.isonig ? 'pink darken-1' :
             this.$props.isonweb ? 'green darken-3' :
             this.$props.ismij ? 'grey lighten-3' : 'indigo',
      txtcolor: this.$props.ismij ? 'red' : 'white',
    };
  },
  methods: {
    chipClose(tag: ITag) {
      this.$emit('delete', tag);
    },
  },
});
